// @ts-strict-ignore
import React, { FC } from 'react'

import { getRegionDomain, TRegion, useRegion } from '@/entities/regions'

import { RegionSelectorType } from '@/shared/types/deprecated-types'

import { NavPointerIcon } from './assets/navigation-pointer-icon'
import { OpenRegionNavButton } from './OpenRegionNavButton/OpenRegionNavButton'
import { ProductRegionSelect } from './variants/product/ProductRegionSelect'

export type RegionSelectorProps = {
	regions: TRegion[]
	activeRegion: TRegion
	changeHandler: (value: string) => void
}

/**
 * Choose current region select-wrap
 * @param type - type of select
 */
export const RegionSelector: FC<{ type?: `${RegionSelectorType}` }> = ({ type = RegionSelectorType.Burger }) => {
	const { allRegions, currentRegion } = useRegion()

	switch (type) {
		case RegionSelectorType.Header:
			return (
				<OpenRegionNavButton>
					<>
						<NavPointerIcon />
						{currentRegion.REGION_NAME}
					</>
				</OpenRegionNavButton>
			)

		case RegionSelectorType.Shops:
			return <OpenRegionNavButton>Изменить город</OpenRegionNavButton>

		case RegionSelectorType.Product:
			return <ProductRegionSelect regions={allRegions} activeRegion={currentRegion} changeHandler={getRegionDomain} />

		default:
			return <OpenRegionNavButton>Изменить город</OpenRegionNavButton>
	}
}
